import moment from 'moment';
import { Button } from '@themesberg/react-bootstrap';
import React from 'react'
import { Link } from 'react-router-dom';
import { Routes } from '../../../../routes';

export const TableRow = (props) => {
  const { ticket, user, netValue, fee, tax, grossValue, isPaid, id, cartGroup } = props.data;

  const device = ticket && ticket.device;

  const _detail = JSON.parse(ticket.detail)

  const images = ticket.images

  const numberRows = _detail.numberRows.map(i => {
    return {
      numbers: i.numbers,
      playMethod: i.playMethod,
      value: i.value
    }
  })

  const l = ['A', 'B', 'C', 'D', 'E', 'F']

  const order = ticket.order

  const cartGroupId = ticket.cartGroupId

  const { onPaidPress, onShowMembersPress } = props;

  const cartGroupLink = cartGroupId ? Routes.VietlottGroupDetail.path.replace(':id', cartGroupId) : null;
  const isCartGroup = !!cartGroupId;

  const members = cartGroup?.cartGroupMembers || [];

  return (
    <tr>
      <td className="text-center">
        <Button onClick={() => props.onShowDetailPress(props.data)}>
          Chi tiết
        </Button>
      </td>
      <td>
        {isCartGroup ? (
          <>
            <Link to={cartGroupLink} target="_blank" style={{ textDecoration: 'underline', color: '#0d6efd' }}>
              <strong>Nhóm: {cartGroupId}</strong>
            </Link>
            <br />
            <span className="text-muted" style={{ fontSize: 13 }}>{members.length} thành viên</span>
            <br />
            <Button variant="outline-primary" size="sm" style={{ marginTop: 4 }} onClick={() => onShowMembersPress(members, cartGroupId, netValue, cartGroup?.estimatedValue)}>
              Xem thành viên
            </Button>
          </>
        ) : (
          <>
            {(user && user.name) || ""}<br />
            <span><strong className={`text-primary`}>{(user && user.phone) || ""}</strong></span>
          </>
        )}
      </td>
      {ticket && <td className='text-center'>
        STT: <b>{order}</b><br />
        <img alt='' src={require(`../../../../assets/img/logo-${ticket.gameId}.png`)} className="img-thumbnail" width={90} height={30}></img><br />
        {ticket && ticket.id}<br /><b>Kỳ quay: {ticket && ticket.gamePeriodId.split('-')[1]}</b>
      </td>}
      <td className='text-center'>
        {device ? (
          <>
            <b>{device.name || device.code}</b><br />
            <span className="text-muted" style={{ fontSize: 12 }}>{device.code}</span>
          </>
        ) : (
          <span className="text-muted">-</span>
        )}
      </td>
      <td>
        Mua lúc: <b>{moment(ticket.createdAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()}</b> <br />
        Hoàn thành lúc: <b>{moment(ticket.printedAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()}</b>
        <br />
        <br />
        {numberRows.map((ii, idx) => {
          if (ticket.gamePeriodId.split('-')[0] === 'lotto535') {
            if (ii.playMethod.includes('GROUP_NORMAL_')) {
              return (
                <>
                  {l[idx]} :
                  <b>{ii.numbers.split(' ').slice(0, ii.numbers.split(' ').length - 1).join(' ')}</b> | <b className='text-danger'>{ii.numbers.split(' ').slice(-1)}</b>
                  {idx < numberRows.length - 1 && <br />}
                </>
              )
            }
            const specialLength = ii.playMethod.split('GROUP_SPECIAL_')[1]
            return (
              <>
                {l[idx]} :
                <b>{ii.numbers.split(' ').slice(0, 5).join(' ')}</b> | <b className='text-danger'>{ii.numbers.split(' ').slice(-specialLength).join(' ')}</b>
                {idx < numberRows.length - 1 && <br />}
              </>
            )
          }
          return (
            <>
              {l[idx]} :
              {ii.numbers.length === 0 && ii.playMethod} <b>{ii.numbers}</b>
              {idx < numberRows.length - 1 && <br />}
            </>
          )
        })}
      </td>
      <td className='text-center'>
        <img alt='' src={images[0] ? images[0] : ''} className="img-thumbnail" width={250}></img>
      </td>
      <td className="text-center text-success">{new Intl.NumberFormat('vn-VI', {}).format(grossValue || 0)}</td>
      <td className="text-center">{new Intl.NumberFormat('vn-VI', {}).format(tax || 0)}</td>
      <td className="text-center">{new Intl.NumberFormat('vn-VI', {}).format(fee || 0)}</td>
      <td className="text-center text-primary">{new Intl.NumberFormat('vn-VI', {}).format(netValue || 0)}</td>
      <td className="text-center text-success">{isPaid ? 'Đã trả thưởng' : <Button variant="danger" className="m-1" onClick={() => onPaidPress(id, user?.id || undefined, cartGroupId || undefined, ticket.id)}>Trả thưởng</Button>}</td>
    </tr>
  );
};